// The Paw Club theme JS

// Sticky "add to cart" bar reveal on product pages
(function () {
  const sticky = document.getElementById('StickyBuy');
  const form = document.querySelector('.product-form');
  if (!sticky || !form) return;

  const onScroll = () => {
    const rect = form.getBoundingClientRect();
    if (rect.bottom < 0) {
      sticky.classList.add('visible');
    } else {
      sticky.classList.remove('visible');
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
})();

// Product gallery thumbnail swap
(function () {
  const main = document.getElementById('MainProductImage');
  const thumbs = document.querySelectorAll('.thumb-btn');
  if (!main || !thumbs.length) return;

  thumbs.forEach((btn) => {
    btn.addEventListener('click', () => {
      main.src = btn.getAttribute('data-full');
    });
  });
})();

// Color swatch selector — swaps the main image AND selects the matching real variant
(function () {
  const main = document.getElementById('MainProductImage');
  const swatches = document.querySelectorAll('.swatch-btn');
  const nameLabel = document.getElementById('SelectedColorName');
  const idField = document.querySelector('.product-form input[name="id"]');
  const swatchImageField = document.getElementById('SwatchImageField');
  const addBtn = document.querySelector('.product-form button[name="add"]');
  const priceEl = document.getElementById('ProductPrice');
  const compareEl = document.getElementById('ProductComparePrice');
  const badgeEl = document.getElementById('ProductOffBadge');
  if (!main || !swatches.length) return;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function applySwatch(btn, swapImage) {
    swatches.forEach((b) => b.classList.remove('active'));
    btn.classList.add('active');

    const colorName = btn.getAttribute('data-color-name');
    const variantId = btn.getAttribute('data-variant-id');
    const available = btn.getAttribute('data-variant-available') === 'true';
    const price = btn.getAttribute('data-variant-price');
    const priceRaw = parseFloat(btn.getAttribute('data-variant-price-raw'));
    let compareRaw = parseFloat(btn.getAttribute('data-variant-compare-raw'));

    if (nameLabel) nameLabel.textContent = colorName;
    if (idField) idField.value = variantId || '';

    if (!isNaN(priceRaw)) {
      if (isNaN(compareRaw) || compareRaw <= priceRaw) compareRaw = 6249;
      const pctOff = Math.round(((compareRaw - priceRaw) / compareRaw) * 100);
      if (priceEl) priceEl.textContent = formatMoney(priceRaw);
      if (compareEl) compareEl.textContent = formatMoney(compareRaw);
      if (badgeEl) badgeEl.textContent = pctOff + '% off';
    } else if (priceEl && price) {
      priceEl.textContent = price;
    }

    if (addBtn) {
      addBtn.disabled = false;
      addBtn.textContent = price ? 'Add to Cart — ' + price : 'Add to Cart';
    }

    const full = btn.getAttribute('data-full-image');
    if (swatchImageField) swatchImageField.value = full || '';
    if (!swapImage || !full) return;

    main.classList.add('swapping');
    const preload = new Image();
    preload.onload = () => {
      main.src = full;
      main.classList.remove('swapping');
    };
    preload.onerror = () => {
      main.classList.remove('swapping');
    };
    preload.src = full;
  }

  swatches.forEach((btn) => {
    btn.addEventListener('click', () => applySwatch(btn, true));
  });

  // Sync the label/button/id to whichever swatch is marked active on page load
  const initiallyActive = document.querySelector('.swatch-btn.active') || swatches[0];
  if (initiallyActive) applySwatch(initiallyActive, false);
})();

// ================= Add to cart (AJAX) =================
(function () {
  if (!window.routes || !window.routes.cart_add_url) return;

  function showToast(message, isError) {
    let toast = document.getElementById('CartToast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'CartToast';
      toast.className = 'cart-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.toggle('cart-toast--error', !!isError);
    toast.classList.add('visible');
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(() => toast.classList.remove('visible'), 2600);
  }

  function updateCartCount() {
    fetch(window.routes.cart_url + '.js')
      .then((res) => res.json())
      .then((cart) => {
        document.querySelectorAll('.cart-count').forEach((el) => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(() => {});
  }

  function handleSubmit(e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    const submitBtn = form.querySelector('button[type="submit"], button[name="add"]');
    const originalText = submitBtn ? submitBtn.textContent : '';

    const idField = form.querySelector('[name="id"]');
    if (!idField || !idField.value) {
      showToast('No product selected — pick a product in the theme editor for this section', true);
      return;
    }

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding…';
    }

    const formData = new FormData(form);

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then((res) =>
        res.json().catch(() => ({})).then((data) => ({ ok: res.ok, status: res.status, data }))
      )
      .then(({ ok, status, data }) => {
        if (!ok) {
          const reason =
            (data && (data.description || data.message)) ||
            (data && data.errors && (Array.isArray(data.errors) ? data.errors.join(', ') : data.errors)) ||
            ('Error ' + status + ' from Shopify');
          throw new Error(reason);
        }
        window.location.href = window.routes.cart_url;
      })
      .catch((err) => {
        showToast(err.message || 'Something went wrong — please try again', true);
      })
      .finally(() => {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
      });
  }

  document.addEventListener('submit', handleSubmit);
})();

// ================= Cart: quantity steppers + remove buttons =================
(function () {
  const root = document.getElementById('CartSectionRoot');
  if (!root || !window.themeCartUrl) return;

  function setBusy(line, busy) {
    if (line) line.classList.toggle('updating', busy);
  }

  function changeLine(line, quantity) {
    const lineEl = root.querySelector('.cart-line[data-line="' + line + '"]');
    setBusy(lineEl, true);
    if (lineEl && quantity === 0) lineEl.classList.add('removing');

    fetch(window.themeCartUrl + '/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then((res) => res.json())
      .then(() => refreshCart())
      .catch(() => {
        setBusy(lineEl, false);
        if (lineEl) lineEl.classList.remove('removing');
      });
  }

  function refreshCart() {
    fetch(window.location.pathname + '?section_id=main')
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newRoot = doc.getElementById('CartSectionRoot');
        if (!newRoot) { window.location.reload(); return; }
        root.replaceWith(newRoot);
        bindCart();
        // keep header cart count in sync if present
        const cartCountEl = document.querySelector('.cart-count');
        fetch(window.themeCartUrl + '.js')
          .then((r) => r.json())
          .then((cart) => {
            if (cartCountEl) {
              if (cart.item_count > 0) {
                cartCountEl.textContent = cart.item_count;
                cartCountEl.style.display = '';
              } else {
                cartCountEl.style.display = 'none';
              }
            }
          })
          .catch(() => {});
      })
      .catch(() => window.location.reload());
  }

  function bindCart() {
    const currentRoot = document.getElementById('CartSectionRoot');
    if (!currentRoot) return;

    currentRoot.querySelectorAll('.cart-line').forEach((lineEl) => {
      const line = parseInt(lineEl.getAttribute('data-line'), 10);
      const qtyValue = lineEl.querySelector('.qty-value');

      const minusBtn = lineEl.querySelector('.qty-minus');
      const plusBtn = lineEl.querySelector('.qty-plus');
      const removeBtn = lineEl.querySelector('.cart-remove-btn');

      if (minusBtn) {
        minusBtn.addEventListener('click', () => {
          const current = parseInt(qtyValue.textContent, 10) || 1;
          const next = Math.max(current - 1, 0);
          changeLine(line, next);
        });
      }
      if (plusBtn) {
        plusBtn.addEventListener('click', () => {
          const current = parseInt(qtyValue.textContent, 10) || 1;
          changeLine(line, current + 1);
        });
      }
      if (removeBtn) {
        removeBtn.addEventListener('click', () => changeLine(line, 0));
      }
    });
  }

  bindCart();
})();
